import {Base} from "@/api/Base"

export class AuthorityDelete extends Base {
    path = "authority/delete"
}